// extracted by css-extract-rspack-plugin
export default {"borderTop":"pqZlA","borderBottom":"MITAm","action":"DpEkY"};